import { Avatar } from "@mantine/core";

interface Props {
  /** Image URL; when empty or failing to load, initials are shown instead. */
  src?: string | null;
  /** Display name used to derive up to two uppercase initials. */
  name?: string | null;
  /** Diameter in px. */
  size?: number;
  className?: string;
}

/**
 * Round entity avatar (sub-client, site, user...). Shows the image when `src`
 * is set and loads; otherwise a grey circle with the name's initials.
 */
const EntityAvatar = ({ src, name, size = 32, className }: Props) => {
  const cleanName = typeof name === "string" ? name.trim().replace(/\s+/g, " ") : "";
  const cleanSrc = typeof src === "string" && src.trim() ? src.trim() : null;

  return (
    <Avatar
      src={cleanSrc}
      name={cleanName || undefined}
      alt={cleanName || undefined}
      size={size}
      radius="xl"
      color="gray"
      variant="light"
      className={className}
    />
  );
};

export default EntityAvatar;
